import React from 'react';
import './backToListBtn.scss';
import { PodTextS18W600Lh18White } from '../../texts/fontText/podkova/TextPodkova';
import { useNavigate } from 'react-router-dom';

const BackToListBtn = () => {
  const navitagte = useNavigate();

  return (
    <div onClick={() => navitagte("/newsTopic")} className="btn-box_back-to-list flex cursor-pointer">
      <div className="btn-box">
        <img src="/seamansclub-news/assets/svg/backToBtn.svg" alt="" className="" />
      </div>
      <PodTextS18W600Lh18White text={'Go To List'} />
    </div>
  );
};

export default BackToListBtn;
